import { Config } from "./Config";

export const Catch = () => {

    if (!Config.appSettings.debug) {

        window.onerror = function (msg, src, lineno, colno, error) {

            // TODO: LOG ERROR
            console.log("Application Error",
                {
                    Message: msg,
                    Src: src,
                    Line: lineno,
                    Column: colno,
                    Error: error
                }
            );

            window.location.href = "/500";

            return false;
        }

    }
}
